<template>
    <div>
        <table-filter class="filter pull-right" v-model="filterModel" :focusOnLoad="focusFilterOnLoad"/>

        <table class="areas-table">
            <thead>
                <th v-for="(header, index) in headers" :key="`${header}-${index}`">
                    {{header}}
                </th>
            </thead>
            <tbody>
                <ExpandableDataTableRow v-for="item in processedItems"
                    :key="item.id.label"
                    :item="item"
                    :label="label"
                    :level="0"
                    :visible="item.visible"
                    :filtered="filter != ''"

                    @select-item="$emit('select-item', $event)"
                    @clone="$emit('clone', $event)"
                    @delete="$emit('delete', $event)"
                    @edit="$emit('edit', $event)"
                    @statistics="$emit('statistics', $event)"
                >
                <slot></slot>
                </ExpandableDataTableRow>
            </tbody>
        </table>
    </div>
</template>

<script>

import _ from 'lodash';
import ExpandableDataTableRow from './ExpandableDataTableRow';
import TableFilter from './Filter.vue';

export default {
    name: 'ExpandableDataTable',
    status: 'prototype',
    release: '0.0.1',
    
    components: {
        ExpandableDataTableRow,
        TableFilter
    },

    props: {
        /**
         * Headers for the columns. This should be an array of strings.
         */
        headers: {
            type: Array,
            required: true,
            validate: (array) => {
                for(let i = 0 ; i < array.length ; i++) {
                    if(typeof array[i] !== 'string') {
                        return false;
                    }
                }
            }
        },

        /**
         * The items to be displayed in the table.
         */
        items: {
            type: Array,
            required: true
        },

        /**
         * Name of the property in items that should be displayed as value.
         */
        label: {
            type: String,
            default: 'label'
        },

        /**
         * Filter text - only items containing the filter text in one of their columns will be displayed
         */
        filter: {
            type: String,
            default: ''
        },

        focusFilterOnLoad: {
            type: Boolean,
            default: false
        }
    },
    
    data() {
        return {
            /**
             * Default properties for table items.
             */
            defaultProperties: {
                children: [],
                visible: true,
                id: { value: this.generateId(), visible: false}
            },
            // filter: ''
        };
    },
    
    computed: {
        /**
         * Process all items into valid table items
         */
        processedItems() {         
            return this.items.map((item) => {
                return this.processItem(item);
            });
        },

        filterModel: {
            get() {
                return this.filter;
            }, 
            set(value) {
                this.$emit('update:filter', value);
            }
        }
    },

    watch: {
        filter(value) {
            this.filterItems();
        }
    },

    methods: {
        /**
         * Generate a random unique id.
         */
        generateId() {
            return '_' + Math.random().toString(36).substr(2, 9);
        },
        /**
         * Merges item and it's children recursivly
         * with the default properties.
         */
        processItem(item) {
            const vm = this;
            item.children = item.children ? item.children : undefined;

            const processed =  _.merge({}, vm.defaultProperties, item);
            const processedChildren = [];

            processed.children.forEach((child) => {
                processedChildren.push(vm.processItem(child));
            });

            processed.children = processedChildren;
            return processed;
        },
        //Very hacky way to filter items. However, because of our use of Fragment, we can't remove items from the
        //displayed dataset as Fragment will break the DOM if we do. Instead we will v-show based on a visible property.
        filterItems() {
            const query = this.filter.toLowerCase();

            const filter = (item) => {
                item.visible = false;
                const properties = Object.values(item);

                for(let i = 0 ; i < properties.length ; i++) {
                    if(String(properties[i]).toLowerCase().indexOf(query) !== -1) {
                        item.visible = true;
                        break;
                    }
                }

                return item.visible;
            };

            this.processedItems.forEach((row) => {
                const rowVisible = filter(row);
                const children = row.children || [];

                if(rowVisible) {
                    children.forEach((child) => {
                        child.visible = true;
                    });
                } else {
                    children.forEach((child) => {
                        if(filter(child)) {
                            row.visible = true;
                        }
                    });
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
    table {
        padding-left: 20px;
        padding-right: 20px;
        width: 100%;
    }

    th {
        text-align: left;
    }

    .filter {
        width: 250px;
        padding-bottom: 20px;
    }

</style>